import React from 'react';
import { TablePaginationConfig } from 'antd/lib/table';
import { FilterValue, SorterResult } from 'antd/lib/table/interface';
import { CustomizableTable } from 'src/components/table/CustomizableTable';
import { IPaginationMeta } from 'src/domain/IPagination';
import { BillProcessingStatus, ICustomerUtilityBill } from 'src/domain/customer-utility-bill/interface';

interface Props {
    dataSource: ICustomerUtilityBill[];
    loading: boolean;
    meta: IPaginationMeta | undefined;
    pagination: { current: number; pageSize: number };
    onChange: (
        pagination: TablePaginationConfig,
        filter: Record<string, FilterValue | null>,
        sorter: SorterResult<ICustomerUtilityBill> | SorterResult<ICustomerUtilityBill>[]
    ) => void;
    selectedRowKeys: React.Key[];
    onSelectionChange: (keys: React.Key[], rows: ICustomerUtilityBill[]) => void;
}

const rowClassName = (r: ICustomerUtilityBill) => {
    const status = r.processingStatus;
    if (status === BillProcessingStatus.ParsingFailed || status === BillProcessingStatus.DownloadFailed) return 'customer-bill-row-failed';
    if (status === BillProcessingStatus.ParsingNeedsReview) return 'customer-bill-row-needs-review';
    return '';
};

export const BillsTable: React.FC<Props> = ({ dataSource, loading, meta, pagination, onChange, selectedRowKeys, onSelectionChange }) => (
    <CustomizableTable<ICustomerUtilityBill>
        rowKey="id"
        size="small"
        className="sites-table"
        showHiddenColumnsCount
        sticky={{ offsetHeader: 62 }}
        loading={loading}
        dataSource={dataSource}
        meta={meta as IPaginationMeta}
        onChange={onChange}
        pagination={{ current: pagination.current, pageSize: pagination.pageSize }}
        rowSelection={{
            selectedRowKeys,
            onChange: onSelectionChange,
            preserveSelectedRowKeys: true,
            columnWidth: 40,
        }}
        // rowClassName={rowClassName}
    />
);
